import { Navigate } from "react-router-dom";
import { useGetAuthorizations } from "@/hooks/useGetAuthorizations";
import ConfiguracaoFormularioIdeiasForm from "@/modules/configuracao-formulario-ideias/components/ConfiguracaoFormularioIdeiasForm";
import { ID_CONFIGURACAO_FORMULARIO_IDEIAS } from "@/utils/constants";

const ConfiguracaoFormularioIdeiasPage = () => {
  const { read: hasReadPermission } = useGetAuthorizations(ID_CONFIGURACAO_FORMULARIO_IDEIAS);
  try {
    if (!hasReadPermission) {
      return <Navigate to="/" replace />;
    }

    return <ConfiguracaoFormularioIdeiasForm />;
  } catch {
    return <Navigate to="/" replace />;
  }
};

export default ConfiguracaoFormularioIdeiasPage;
